<template>
  <TranslationFormPart
      id="defaultpairingscreen"
      key="defaultpairingscreen"
      :form-settings="translationFormSettings"
      :disabled="!isEditable"
      :top-border="true"
      :section-title="$gettext('Výchozí párovací obrazovka')"
      v-model="entity.default_pairing_screen"
  />
</template>

<script>

import TranslationFormPart from "../../../common/TranslationFormPart.vue";

export default {
  name: "DefaultPairingScreen",
  components: {TranslationFormPart},
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  data(){
    return {
      translationFormSettings: [
        {
          name: "title",
          type: "text",
          title: this.$gettext("Titulek výchozí obrazovky"),
          required: false,
        },
        {
          name: "body_html",
          type: "textarea",
          title: this.$gettext("HTML výchozí obrazovky"),
          required: false,
        }
      ]
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/initialProcessSetup/forms/DefaultPairingScreen.vue